import { useState } from "react";
import styles from "./accordion.module.scss";

export default function Accordion({ accordionData }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={styles.accordionContainer}>
      {accordionData.map((item, index) => (
        <div key={index} className={styles.accordionItem}>
          <button
            onClick={() => {
              item.onClick && item.onClick();
              toggleAccordion(index);
            }}
            className={styles.accordionHeader}
          >
            {item.header}
            <svg
              width="16"
              height="10"
              viewBox="0 0 16 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={openIndex === index ? styles.rotated : ""}
              aria-hidden
            >
              <path
                d="M7.42932 9.73453C7.74024 10.0885 8.2597 10.0885 8.57141 9.73453L15.7638 1.56728C16.0787 1.20878 16.0787 0.627382 15.7638 0.269786C15.4489 -0.0887184 14.9374 -0.0887184 14.6225 0.269786L8 7.78824L1.37828 0.268878C1.06258 -0.0896263 0.551883 -0.0896263 0.236179 0.268878C-0.0787258 0.627382 -0.0787258 1.20878 0.236179 1.56638L7.42932 9.73453Z"
                fill="#CDD2D7"
              />
            </svg>
          </button>
          <div
            className={`${styles.accordionContent} ${
              openIndex === index ? styles.open : ""
            }`}
          >
            {item.content}
          </div>
        </div>
      ))}
    </div>
  );
}
